exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center[data-v-5ef75ef4] {\n  text-align: center;\n  padding-top: 10%;\n}\n", ""]);

// exports
